// extracted by mini-css-extract-plugin
module.exports = {"default":"Navbar_default__1ReEi"};